import { jsx as _jsx } from "preact/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState, } from 'react';
import useGlobalEvent from 'beautiful-react-hooks/useGlobalEvent';
import UpsellModalContent from '@widgets/UpsellModal/components/UpsellModalContent';
const UpsellContext = createContext({
    contentVisible: false,
    setContentVisible: (contentVisible) => null,
    backgroundVisible: false,
    setBackgroundVisible: (backgroundVisible) => null,
    modalOpen: false,
    setModalOpen: (modalOpen) => null,
    upsell: undefined,
    setUpsell: (upsell) => undefined,
    handleModalClose: () => null,
});
export const useUpsellModal = () => {
    const value = useContext(UpsellContext);
    return value ?? {};
};
function UpsellModal() {
    const [modalOpen, setModalOpen] = useState(false);
    const [upsell, setUpsell] = useState(undefined);
    const [contentVisible, setContentVisible] = useState(true);
    const [backgroundVisible, setBackgroundVisible] = useState(true);
    const onUpsellOpen = useGlobalEvent('upsell.open');
    const onUpsellClose = useGlobalEvent('upsell.close');
    onUpsellOpen((event) => {
        console.log({
            upsell: event.detail,
            type: typeof event.detail,
        });
        setUpsell(event.detail);
        setModalOpen(true);
    });
    const handleModalClose = useCallback(() => {
        setContentVisible(true);
        setBackgroundVisible(true);
        setUpsell(undefined);
        setModalOpen(false);
    }, []);
    const handleModalComplete = useCallback(() => {
        if (upsell) {
            window.dispatchEvent(new CustomEvent('upsell.added', {
                detail: upsell.id,
            }));
            if (upsell.submissionTarget) {
                window.location.href = upsell.submissionTarget;
            }
        }
        handleModalClose();
    }, [handleModalClose, upsell]);
    onUpsellClose(handleModalClose);
    const value = useMemo(() => ({
        contentVisible,
        backgroundVisible,
        setContentVisible,
        setBackgroundVisible,
        modalOpen,
        setModalOpen,
        upsell,
        setUpsell,
        handleModalClose,
    }), [backgroundVisible, contentVisible, handleModalClose, modalOpen, upsell]);
    // if (!modalOpen || !upsell) {
    //   return null;
    // }
    return (_jsx(UpsellContext.Provider, { value: value, children: (modalOpen && upsell) && (_jsx(UpsellModalContent, { onComplete: handleModalComplete })) }));
}
export default UpsellModal;
